import { createSlice } from "@reduxjs/toolkit";

const initialUniState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  lastError: null,
  topicForEdit: undefined,
  error: null,
  groupOptions: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const forumGroupTopicSlice = createSlice({
  name: "topic",
  initialState: initialUniState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // gettopicById
    topicFetched: (state, action) => {
      state.actionsLoading = false;
      state.topicForEdit = action.payload.topicForEdit;
      state.error = null;
    },

    // findtopic
    allTopicFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },

    // createtopic
    topicCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload);
    },

    // updatetopic
    topicUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.id !== action.payload.id
      );
    },

    // deletetopic
    topicDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.topicId !== action.payload.id
      );
    },

    // deletetopic
    topicHardDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        (el) => el.topicId !== action.payload.id
      );
    },

    statusFetched: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.statusOverview = action.payload.statusOverview;
    },

    groupFetched: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.groupOptions = action.payload.groupOptions;
    },
  },
});
